import { capitalize } from './string-helpers.js';
/**
 * Given a an array of strings, creates an object of arrays with label and value keys.
 * Label is capitalized and value is typed as a union of string literals from the input.
 * Convenient for FilterSelect (react-select).
 */
export const getLabelOptions = (strings) => strings.map(str => ({ label: capitalize(str), value: str }));
